const File = require("./File");

class Files {
  constructor() {
    this._files = [];
  }

  /**
   * Adds a file to the collections of files
   *
   * @param {File} file
   */
  add(file) {
    this._files.push(file);
  }

  /**
   * Gets a count of the total number of files in the collection
   *
   * @return {number}
   */
  get count() {
    return this._files.length;
  }

  /**
   * Retrieves a file based on the index inside the files collection
   *
   * @param {Integer} index
   * @return {File|undefined}
   */
  getByIndex(index) {
    return this._files[index];
  }

  /**
   * Retrieves a file based on the file id
   *
   * @param {Integer} fileId
   * @return {File|undefined}
   */
  getByFileId(fileId) {
    return this._files.find(file => file.id === fileId);
  }

  /**
   * Removes a file from the list based on the file id
   *
   * @param fileId
   */
  removeByFileId(fileId) {
    const index = this._files.findIndex(file => file.id === fileId);
    this._files.splice(index, 1);
  }

  /**
   * Retrieves all the files
   *
   * @return {Array}
   */
  get files() {
    return this._files;
  }

  /**
   * Retrieves the files as un-formatted list
   *
   * @return {Object}
   */
  getList() {
    return this._files.map(file => {
      return {id: file.id, name: file.name, version: file.version, active: file.active}
    });
  }

  /**
   * Sets a file as active in the already loaded set
   */
  setFileAsActive(fileId) {
    this._files = this._files.map(file => {
      let active = false;

      if(file.id === fileId) {
        active = true;
      }

      return new File(file.id, file.name, file.version, file.user, file.company, file.segments, active);
    })
  }
}

module.exports = Files;
